/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKeysAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 7a5 5 0 1 0-6.015 4.897V13H4v2h1.985v2H3v2h4.985v-7.097A5.002 5.002 0 0 0 12 7zM7 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" />
        <path d="m21.311 18.919-3.525 3.525-1.414-1.414 2.11-2.111-1.413-1.415-1.404 1.404-1.414-1.414 1.404-1.404-.78-.78a5.002 5.002 0 0 1-6.28-.645l1.414-1.414a3 3 0 1 0 2.774-5.05l.434-1.952a5.002 5.002 0 0 1 3.076 7.652zM18 2v2h-2v2h2v2h2V6h2V4h-2V2z" />
      </g>
    </g>
  </Icon>
);
export { SvgKeysAdd as KeysAdd };
